exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sf-color {\n  display: inline;\n  position: relative;\n}\n.sf-color__label {\n  width: 25px;\n  height: 25px;\n  border: 3px solid #FCF6F3;\n  border-radius: 100%;\n  box-shadow: 0 0 4px #A4ADB5;\n}\n.sf-color__picker {\n  position: absolute;\n  z-index: 2;\n}\n", ""]);

// exports
